import React, { useRef, useState } from "react";
import "./ResetCodePage.css";
import { verifyOTP } from '../../_services/authServices'
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Loader from '../../components/Loader';
import AlertBox from '../../components/AlertBox';
import { useUser } from "../../context/UserContext";

const ResetCodePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const emailAddress = params.get("emailAddress");
  const [alert, setAlert] = useState({ show: false, message: "", type: "info" });
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const inputs = useRef([]);
  const { login } = useUser();
  
  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const updated = [...code];
    updated[index] = value;
    setCode(updated);

    if (value && index < 5) {
      inputs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (code[index]) {
        const updated = [...code];
        updated[index] = "";
        setCode(updated);
      } else if (index > 0) {
        inputs.current[index - 1].focus();
      }
    }

    if (e.key === "ArrowLeft" && index > 0) {
      inputs.current[index - 1].focus();
    }

    if (e.key === "ArrowRight" && index < 5) {
      inputs.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();

    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 6)
      .split("");

    if (!pasted.length) return;

    const updated = [...code];

    pasted.forEach((digit, i) => {
      updated[i] = digit;
    });

    setCode(updated);

    const next = Math.min(pasted.length, 5);
    inputs.current[next].focus();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
  
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setLoading(true);
    setValidated(true);


    const otp = code.join("");

    try {
      const result = await verifyOTP(emailAddress, otp);
      
      if (result.success === true) {
        const accessToken = result.data.accessToken;
        const refreshToken = result.data.refreshToken;
        const user = result.data.user;

        login(user, accessToken, refreshToken);

        setAlert({
          show: true,
          message: result.message,
          type: "success",
        });
        setLoading(false);
        navigate(`/update-password`);
      }else{
        setTimeout(() => {
          setAlert({
            show: true,
            message: result.message,
            type: "error",
          });
          setLoading(false);
        }, 2000);
        
      }
    } catch (error) {
      setTimeout(() => {
        setAlert({
          show: true,
          message: error.message || `Something went wrong. Please try again.`,
          type: "error",
        });
      setLoading(false);
      }, 2000);
    } 
  };

  return (
    <div className="otp-wrapper">
      <Loader show={loading} message="Processing, please wait..." />
      
      <AlertBox
        show={alert.show}
        message={alert.message}
        type={alert.type}
        onClose={() => setAlert({ ...alert, show: false })}
      />
      <div className="otp-card">

        <h2>Account Verification</h2>

        <p>
          Enter the 6-digit verification code sent to your email.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="otp-container" onPaste={handlePaste}>
            {code.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputs.current[index] = el)}
                type="text"
                maxLength={1}
                value={digit}
                onChange={(e) =>
                  handleChange(e.target.value, index)
                }
                onKeyDown={(e) =>
                  handleKeyDown(e, index)
                }
              />
            ))}
          </div>

          <button type="submit">
            Verify Code
          </button>

          <div className="resend">
            Didn't receive the code?
            <a href="/forgot-password"
              type="button"
              className="link-btn"
            >
              Resend Code
            </a>
        <p className="register-text">
          Wanna Login instead?{" "}
        <a href="/login">Login</a>
        </p>
          </div>
        </form>

      </div>
    </div>
  );
};

export default ResetCodePage;